<div class="mainContainer">
    <div class="filter_show">
        <h2 class="log_track">Closed Mess Inventory Details</h2>
    </div>
    <div class="mess-box">
        <div class="icon_flex">
            <p class="search_title">Search :</p>
            <input type="text" name="" id="" placeholder="Search" (input)="onfilterChange($event)"
                class="form-control search_input">

        </div>

        <div class="content" style="width: 100%; height: 40%;">
            <ag-grid-angular style="width: 100%; height: 400px;" [rowData]="rowData" [columnDefs]="colDefs"
                [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" [rowHeight]="45"
                [quickFilterText]="quickFilter" [overlayLoadingTemplate]="overlayLoadingTemplate"
                [overlayNoRowsTemplate]="overlayNoRowsTemplate" (rowClicked)="onRowClicked($event)"
                [rowStyle]="{ cursor: 'pointer' }" />
        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>